/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import computedFirst from 'cio/utils/computed-first';
import MergeEventViewer from 'cio/components/action-composer/context-viewer/merge-event-viewer';
import CampaignModel from 'cio/models/campaign';
import ComposerEditableEntity from 'cio/utils/composer/composer-editable-entity';

const ATTRIBUTE_LIMIT = 60;

export interface MergeAttributeListArgs {
  editableEntity: ComposerEditableEntity;
  attributes: MergeEventViewer['eventAttrs'];
  liquidPrefix?: string;
  liquidPath?: (string | number)[];
  isLiquidInsertionDisabled: boolean;
  insertLiquid: (event: Event | null, value: string) => unknown;
  filterAttribute: string;
  highlightAttribute: boolean;
  campaign: CampaignModel;
  hasReadOnlyPermission: boolean;
  // Backend treats event attributes JSON-encoded values as strings.
  noJsonParsing?: boolean;
}

export default class MergeAttributeList extends Component<MergeAttributeListArgs> {
  @tracked previousFilterAttribute = '';
  @tracked filterAttributeChanged = false;

  @computedFirst('args.attributes', ATTRIBUTE_LIMIT)
  limitedAttributes!: MergeAttributeListArgs['attributes'];

  @computed('args.attributes.length')
  get hiddenAttributeCount() {
    return Math.max(0, this.args.attributes.length - ATTRIBUTE_LIMIT);
  }

  @action
  updatePreviousAttribute() {
    this.filterAttributeChanged = this.args.filterAttribute !== this.previousFilterAttribute;
    this.previousFilterAttribute = this.args.filterAttribute;
  }
}
